module.exports = new __parcel__URL__("plans-standard-light.fde35b0d.svg").toString();